import { apiService } from "../../app.service";

export const cleaningApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchCleaningItems: builder.query({
      query: ({ locationId, includeInactive = false } = {}) => {
        const params = new URLSearchParams();
        if (locationId) params.set("locationId", locationId);
        if (includeInactive) params.set("includeInactive", "true");
        const qs = params.toString();
        return { url: `/cleaning/items${qs ? `?${qs}` : ""}` };
      },
      providesTags: ["cleaningItems"],
    }),
    createCleaningItem: builder.mutation({
      query: ({ name, locationId }) => ({
        url: `/cleaning/items${locationId ? `?locationId=${locationId}` : ""}`,
        method: "POST",
        body: { name },
      }),
      invalidatesTags: ["cleaningItems"],
    }),
    updateCleaningItem: builder.mutation({
      query: ({ id, data, locationId }) => ({
        url: `/cleaning/items/${id}${locationId ? `?locationId=${locationId}` : ""}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["cleaningItems"],
    }),
    deleteCleaningItem: builder.mutation({
      query: ({ id, locationId }) => ({
        url: `/cleaning/items/${id}${locationId ? `?locationId=${locationId}` : ""}`,
        method: "DELETE",
      }),
      invalidatesTags: ["cleaningItems"],
    }),
    fetchCleaningLogs: builder.query({
      query: (locationId) => ({
        url: `/cleaning/logs${locationId ? `?locationId=${locationId}` : ""}`,
      }),
      providesTags: ["cleaningLogs"],
    }),
    createCleaningLog: builder.mutation({
      query: ({ itemId, notes, photo, locationId }) => {
        const formData = new FormData();
        formData.append("itemId", itemId);
        if (notes) formData.append("notes", notes);
        if (photo) formData.append("image", photo);

        return {
          url: `/cleaning/logs${locationId ? `?locationId=${locationId}` : ""}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["cleaningLogs"],
    }),
    deleteCleaningLog: builder.mutation({
      query: ({ id, locationId }) => ({
        url: `/cleaning/logs/${id}${locationId ? `?locationId=${locationId}` : ""}`,
        method: "DELETE",
      }),
      invalidatesTags: ["cleaningLogs"],
    }),
  }),
});

export const {
  useFetchCleaningItemsQuery,
  useCreateCleaningItemMutation,
  useUpdateCleaningItemMutation,
  useDeleteCleaningItemMutation,
  useFetchCleaningLogsQuery,
  useCreateCleaningLogMutation,
  useDeleteCleaningLogMutation,
} = cleaningApi;
